module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-pohyb"
    }
  }, [_c('h1', [_vm._v(" " + _vm._s(_vm._f("translate")('How active is @name?', {
    '@name': _vm.mazlicek.jmeno.value
  })))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAktivitaValid() && this.tryescape),
      expression: "!isAktivitaValid() && this.tryescape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isAktivitaValid() && this.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('You have to select the activity of your dog')) + "\n        ")]) : _vm._e()]), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isAktivitaValid() && this.tryescape, 'has-success': _vm.isAktivitaValid() && this.tryescape
    }
  }, _vm._l((_vm.pohybItems), function(item) {
    return _c('div', {
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.pohyb.id),
        expression: "mazlicek.pohyb.id"
      }],
      attrs: {
        "type": "radio",
        "id": item.id
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.mazlicek.pohyb.id, item.id)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.mazlicek.pohyb, "id", item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('info', {
    attrs: {
      "krok": 7
    }
  }) : _c('div', {
    staticClass: "infobox"
  }, [_vm._v(_vm._s(_vm._f("translate")("For an adult dog, you have to select how active it is. For puppies, this is not relevant for the calculation of Haffit. Choose the 'Continue' button.")) + "\n    ")]), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6280b239","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/07Pohyb.vue
// module id = 552
// module chunks = 1